module.exports = __webpack_public_path__ + "img/google-pay.7d6c693c.png";